import { GameStatus } from '@betterpool/api-types/games-service';

import type { PlayerDetail } from '~/domains/games/interfaces/player-detail.interface';
import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';
import type { PickForEntry } from '~/domains/contest/domains/services/interfaces/picks-for-entry.interface';

import type { PlayerInfo } from '../../types/player';

import parseNonScheduledTeamSport from './parseNonScheduledTeamSport';
import parseScheduledTeamSport from './parseScheduledTeamSport';
import parseBasePlayerInfoTeamSport from './parseBasePlayerInfoTeamSport';
import { AddRankSuffix } from '~/components/utils/formatters';

const parseNonScheduledHockey = (
  pickWithLiveData: PickForEntry | PlayerDetail
): Partial<PlayerInfo> => {
  const isLive = pickWithLiveData.attributes.gameStatus === GameStatus.IN_PROGRESS;

  return {
    gameTime: (() => {
      if (!isLive) {
        return 'FINAL';
      }

      if (
        !pickWithLiveData.attributes?.summary?.clock ||
        !pickWithLiveData.attributes?.summary?.period
      )
        return '-';
      return pickWithLiveData.attributes.summary.period > 3
        ? 'OT' // handle shootout, if period is greater than 3, it's overtime but if its 4 its a shootout, but playoffs its always overtime
        : `${pickWithLiveData.attributes.summary.clock} ${pickWithLiveData.attributes.summary.period} ${AddRankSuffix(pickWithLiveData.attributes.summary.period)}`;
    })(),
  };
};

const parseNonScheduled = (pickWithLiveData: PickForEntry | PlayerDetail) => ({
  ...parseNonScheduledHockey(pickWithLiveData),
  ...parseNonScheduledTeamSport(pickWithLiveData),
});

const parseHockeyPlayerInfo = (
  pick: PlayerPoolMember,
  pickWithLiveData?: PickForEntry
): Partial<PlayerInfo> => ({
  ...(pick.attributes.gameStatus === GameStatus.SCHEDULED || !pickWithLiveData
    ? parseScheduledTeamSport(pick)
    : parseNonScheduled(pickWithLiveData)),
  ...parseBasePlayerInfoTeamSport(pick),
});

export { parseNonScheduled as parseHockeyPlayerInfoAfterGameStart };

export default parseHockeyPlayerInfo;
